export function checkUsername(username: string): string[] {
  const errors: string[] = [];
  if (!/\S+@\S+\.\S+/.test(username)) errors.push('Must use email format: email@example.com');

  // more rules here;

  return errors;
}
export function checkUsernameLength(username: string): string[] {
  const errors: string[] = [];
  if (username.length < 5) errors.push('Username must be at least 5 characters long.');
  if (username.length > 20) errors.push('Username must be at most 20 characters long.');

  return errors;
}
export function checkUsernameCharacters(username: string): string[] {
  const errors: string[] = [];
  if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(username)) {
    errors.push('Username can only contain letters, numbers, dots, underscores, and hyphens.');
  }

  return errors;
}
